<template>
    <div ref="biChartRef" class="company-bi-chart ">
        <div v-if="isEmptyChart" class="chart-no-data flex h-full w-full flex-col items-center justify-center">
            <CatHole2 class="mb-2 h-[50px] w-[70px]"/>
            <div class="text-sm text-grey-90">{{ t('report.chartNoData') }}</div>
        </div>
        <div v-else class="company-bi-chart-container relative flex h-full w-full items-center justify-center">
            <span v-if="props.isLoading || !isChartLoaded" class="th-loading th-loading-spinner th-loading-lg absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2 bg-grey-200"></span>
            <div flex="o" :class="`${containerClass} w-full h-full`" v-show="!props.isLoading">
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { withDefaults, ref } from 'vue';
import { useBIChart } from '@/composables/use-bi-chart';
import { useI18n } from 'vue-i18n';
import { CatHole2 } from '@eureka/cat'
import { useResizeObserver } from '@vueuse/core';

const { t } = useI18n()
const props = withDefaults(defineProps<{
    configTaskFunc:() => Promise<any>,
    dataTaskFunc: () => Promise<any>,
    colorFunc?: (data: any[]) => any[],
    chartKey: string,
    isLoading: boolean,
    chartType: string,
}>(), {
    isLoading: true,
});

const emits = defineEmits<{
    (event: 'click', data: any): void;
    (event: 'visualReady', data: unknown): void;
}>();
const biChartRef = ref(null);

const { containerClass, isChartLoaded, drawChart, generateChartImage, visualCurr, isEmptyChart, clearSelect } = useBIChart(props, emits);

useResizeObserver(biChartRef, () => {
    visualCurr.value?.resize?.();
});

defineExpose({
    drawChart,
    isChartLoaded,
    generateChartImage,
    clearSelect,
    isEmptyChart,
});

</script>

<style lang="scss">
.company-bi-chart-container {
    .world-cloud-wrapper {
        overflow: visible;
        .chart-tooltips-wrapper {
            font-size: 12px;
            line-height: 18px;
        }
    }
    svg.world-cloud {
        width: 100%;
    }
    svg[icon="SolidLoadingBars"] {
        font-size: 64px;
    }
}
</style>
